import { AppConfiguration } from '@hec/models';

export const UPDATE_APP_CONFIGURATION = 'UPDATE_APP_CONFIGURATION';

export const UpdateAppConfiguration = (appConfiguration: AppConfiguration) => ({
  type: UPDATE_APP_CONFIGURATION,
  data: appConfiguration,
});
